import React from 'react'

export const ReportHeaderView = ({organization, headerLayout, getResource}) => (
    <div className="header-info">
        {organization.logo &&
        <div className="organization-logo"
             style={{backgroundImage: 'url("' + getResource(organization.logo) + '")'}}/>}
        <div className="organization-details">
            {organization.organizationName.trim() &&
            <span className="organization-name">{organization.organizationName}</span>}
            <div className="address-details">
                {organization.address.trim() && <span className="address">{organization.address} </span>}
                {organization.city.trim() && <span className="city">{organization.city}</span>}
                {organization.state.trim() && <span className="state">{organization.state}</span>}
                {organization.zipCode.trim() && <span className="zipcode">{organization.zipCode}</span>}
                {organization.country.trim() && <span className="country">{organization.country} </span>}
            </div>
            {organization.phoneNumber.trim() && <span className="phone">Phone: {organization.phoneNumber} </span>}
            {organization.faxNumber.trim() && <span className="fax">Fax: {organization.faxNumber} </span>}
            {organization.email.trim() && <span className="email">Email: {organization.email} </span>}
        </div>
    </div>
)




// WEBPACK FOOTER //
// ./~/report-components/src/modules/viewer/ReportHeaderView.jsx